import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { Button, Col, Row, notification } from 'antd'
import { __product } from '../__product'
import productSplitPaymentsController from './productSplitPayments.controller'
import { GatewaySplitEditor } from '../../../../components/GatewaySplitEditor'
import PaymentGatewayController from '../../../settings/payment/payment.gateway.controller'
import i from '../../../../translations/i'

// Правило распределения суммы этого товара между платёжными шлюзами ЮKassa.
// Если не задано — используется глобальное правило по умолчанию (Настройки → Разделение платежей).
export const ProductSplitPayments = observer(() => {

  useEffect(() => {
    PaymentGatewayController.getList()

    if(__product.item.id > 0)
      productSplitPaymentsController.get(__product.item.id)
  }, [__product.item.id])

  const [saving, setSaving] = React.useState(false)

  const handleSave = () => {
    setSaving(true)
    productSplitPaymentsController.save()
      .then(() => {
        notification.success({
          message: i.t('def:success.success'),
          description: i.t('def:success.edit'),
        })
      })
      .catch((error: any) => {
        notification.error({
          message: i.t('def:errors.error'),
          description: error?.response?.data?.data?.message ?? ''
        })
      })
      .finally(() => setSaving(false))
  }

  if(!productSplitPaymentsController.render)
    return <></>

  return(
    <Row gutter={[20, 20]}>
      <Col span={24}>
        <label className="formLabel">{i.t('product:splitPaymentDistribution')}</label>
        <GatewaySplitEditor rows={productSplitPaymentsController.rows} onChange={(rows) => productSplitPaymentsController.setRows(rows)} />
      </Col>

      <Col span={24}>
        <Button type="primary" loading={saving} onClick={handleSave}>
          {i.t('def:actions.save')}
        </Button>
      </Col>
    </Row>
  )
})
